'use client'

import { GET_PROFILE_QUERY_KEY } from '@partment/types'
import { useQuery } from '@tanstack/react-query'
import { useSession } from 'next-auth/react'
import { getProfile } from '..'

export const useProfileDetails = () => {
  const { data: session, status } = useSession()

  return useQuery({
    queryKey: [GET_PROFILE_QUERY_KEY],
    queryFn: getProfile,
    enabled: status === 'authenticated' && Boolean(session?.access_token),
    retry: false,
  })
}
